// "Executive brief" (mockup D) tokens for the meeting document. Light paper on purpose: this
// document is client-facing, unlike the dark Ops Hub chrome around it.
export const paper = {
  bg: "#f4f1ea", card: "#ffffff", line: "#ddd6c7", lineSoft: "#ece6d8",
  ink: "#1b2130", inkSoft: "#373e4e", muted: "#5a6173",
  accent: "#1d4ed8", accentBg: "#e2eafc", success: "#15803d",
  warnBg: "#fff7e8", warnLine: "#f0d9a8", warnInk: "#92400e", danger: "#b91c1c",
};
export const serif = "Fraunces, Georgia, serif";
export const sans = "'DM Sans', sans-serif";
